import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUserAction } from "../../../redux/slices/users/usersSlice";
import ErrorMsg from "../../ErrorMsg/ErrorMsg";
import LoadingComponent from "../../LoadingComp/LoadingComponent";
import logo from "../../../assets/img/nutrad_large.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [displayError, setDisplayError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { email, password } = formData;

  const { error, loading, userInfo } = useSelector(
    (state) => state?.users?.userAuth
  );

  const onChangeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (displayError) {
      setDisplayError(false);
    }
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    dispatch(loginUserAction({ email, password }));
    if (error) {
      setDisplayError(true);
    }
  };

  useEffect(() => {
    if (userInfo) {
      window.location.href = "/";
    }
  }, [userInfo]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl w-full space-y-8 relative">
        {/* Background accent */}
        <div className="absolute inset-0 bg-blue-100 transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 rounded-3xl" />
        
        {/* Main content container */}
        <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            {/* Form section */}
            <div className="w-full md:w-3/5 p-8 sm:p-12">
              <div className="max-w-md mx-auto">
                <h2 className="text-4xl font-bold text-gray-900 mb-8">Login</h2>
                
                {displayError && error && (
                  <div className="mb-6">
                    <ErrorMsg message={error?.message} />
                  </div>
                )}

                <form onSubmit={onSubmitHandler} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 uppercase tracking-wider mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={onChangeHandler}
                      required
                      className="appearance-none block w-full px-3 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter your email"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 uppercase tracking-wider mb-2">
                      Password
                    </label>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={password}
                        onChange={onChangeHandler}
                        required
                        className="appearance-none block w-full px-3 py-3 pr-10 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter your password"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                        tabIndex={-1}
                      >
                        {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                      </button>
                    </div>
                  </div>

                  <div>
                    {loading ? (
                      <div className="flex justify-center">
                        <LoadingComponent />
                      </div>
                    ) : (
                      <button
                        type="submit"
                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transform transition-all duration-150 hover:scale-[1.02]"
                      >
                        Sign in
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>

            {/* Logo section */}
            <div className="w-full md:w-2/5 bg-gray-50 flex items-center justify-center p-8">
              <div className="max-w-sm w-full">
                <img
                  src={logo}
                  alt="Nutrad Logo"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;